import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil, tap } from 'rxjs/operators';

import { TWorkspacesById } from 'src/app/project/modules/workspace/workspace.model';

import { ActiveService } from 'src/app/project/services/active/active.service';

import { translate } from '../../features/translate/translate';
import { EIconPath } from '../../shared/enums/icons.enum';
import { EStore } from '../../shared/enums/store.enum';
import { CustomTableService } from '../site/site-table/custom-table/custom-table.service';
import { checkCustomWorkspaceId } from '../workspace/workspace';
import { EWorkspaces } from '../workspace/workspaces.enum';
import { QuickFilterService } from './filters-api/search/quick-filter-service';

const KEYWORD_DEBOUNCE_MS = 1000;

@Component({
  selector: 'pp-site-filter',
  templateUrl: './site-filter.component.html',
  styleUrls: ['./site-filter.component.scss'],
  standalone: false,
})
export class SiteFilterComponent implements OnInit, OnDestroy {
  @Input() ppIsReminder = false;

  private readonly destroy$ = new Subject<void>();
  readonly filter$ = new Subject<string>();

  hovered = false;
  focused = false;
  placeholder = '';
  keyword = '';

  private workspaces$ = new Observable<TWorkspacesById>();
  workspaceId: string;
  EWorkspaces = EWorkspaces;
  EIconPath = EIconPath;

  constructor(
    private store: Store<{
      workspaces: TWorkspacesById;
    }>,
    private activeService: ActiveService,
    private customTableService: CustomTableService,
    private quickFilterService: QuickFilterService,
  ) {
    this.workspaces$ = this.store.pipe(select(EStore.WORKSPACES));

    this.quickFilterService
      .getFiltersChange$()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.keyword = this.quickFilterService.getKeyword();
      });

    this.workspaces$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.workspaceId = checkCustomWorkspaceId() || this.activeService.getActiveWorkspaceId();

      this.keyword = this.quickFilterService.getKeyword();
    });
  }

  ngOnInit(): void {
    this.filter$
      .pipe(
        takeUntil(this.destroy$),
        debounceTime(KEYWORD_DEBOUNCE_MS),
        distinctUntilChanged(),
        tap((keyword) => {
          this.filterByName(keyword);
        }),
      )
      .subscribe();

    this.setPlaceholder();
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  setPlaceholder(): void {
    if (this.ppIsReminder) {
      this.placeholder = translate('search_for_reminder');
    } else {
      this.placeholder =
        this.workspaceId === EWorkspaces.OVERVIEW
          ? translate('search_overview')
          : translate('search_this_site');
    }
  }

  clearSearchKeywords(): void {
    this.keyword = '';
    this.filterByName(this.keyword);
  }

  setHovered(isHovered: boolean): void {
    this.hovered = isHovered;
  }

  setFocused(isFocused: boolean): void {
    this.focused = isFocused;
  }

  private filterByName(keyword: string): void {
    this.quickFilterService.setKeyword(keyword);
    this.customTableService.reloadTable();
  }
}
